import { useState, useEffect } from "react";
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";

import Routes from "./index";

let menus = [];

Routes.forEach((item, index) => {
  if (item.key === "login") {
    return;
  }
  let obj = {
    key: item.path,
    label: item.label,
  };
  if (item.children) {
    item.children.forEach((citem, i) => {
      citem.key = item.path + "-" + citem.path;
    });
    obj.children = item.children;
  }
  menus.push(obj);
});

const App = () => {
  const [defaultOpenKeys, setDefaultOpenKeys] = useState([]);
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState(["/"]);
  const [openKeys, setOpenKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState(["/"]);

  useEffect(() => {
    if (window.location.pathname === "/") {
      return;
    }
    const keys = window.location.pathname.split("/").filter(Boolean);
    const openKeysTemp = keys[0];
    const selectKeysTemp = keys.join("-");
    setSelectedKeys([selectKeysTemp]);
    setOpenKeys([openKeysTemp]);
    setDefaultOpenKeys([openKeysTemp]);
    setDefaultSelectedKeys([selectKeysTemp]);
  }, []);

  const navigate = useNavigate();

  function goPath(e) {
    if (e.key === "/") {
      navigate("");
      return;
    }
    let keys = e.key.split("-");
    let path = keys[0] + (keys[1] ? "/" + keys[1] : "");
    navigate(path);
  }

  return (
    <Menu
      mode="inline"
      theme="dark"
      inlineCollapsed={false}
      items={menus}
      onClick={goPath}
      defaultOpenKeys={defaultOpenKeys}
      defaultSelectedKeys={defaultSelectedKeys}
      openKeys={openKeys}
      selectedKeys={selectedKeys}
      onOpenChange={(keys) => setOpenKeys(keys)}
      onSelect={(select) => setSelectedKeys(select.selectedKeys)}
    />
  );
};

export default App;
